import React, { Fragment } from "react"
import uuid from "uuid"
import { get, orderBy, find, filter, isArray, isEmpty } from "lodash"
import { connect } from "react-redux"
import styled from "styled-components"
import Popover from "@material-ui/core/Popover"

import { fetchData, removeData, showToast, showPopup } from "../../store/action"
import PrimaryButton from "../../components/buttons/PrimaryButton"
import BidValue from "../../components/BidValue"
import AboutBidding from "./AboutBidding"
import config from "../../Config"
import { replaceWithSymbol } from "../../util/cutString"
import { event } from "../../components/reactGA"
import i18n from "../../i18n"
import Cookie from "../../util/Cookie"
import BidTab from "../../components/bidTab/bidTab"
import BidType from "../../components/BidType"
// import Tooltip from "@material-ui/core/Tooltip"

const Header = styled.div`
  display: flex;
  height: 56px;
  background-color: #000;
  color: #fff;
  display: flex;
  align-items: center;
  padding: 0px 20px;
`

const Label = styled.span`
  font-family: montserratRegular;
  font-size: 16px;
  font-weight: 500;
  margin-left: 20px;
  flex: 3;
  text-align: left;
`

const NoBidFoundContainer = styled.div`
  background-color: #1c1d23;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const BidFoundContainer = styled.div`
  background-color: #1c1d23;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 20px;
`

const BidFoundHeader = styled.div`
  display: flex;
  padding: 10px;
  justify-content: center;
`

const ImageWrapper = styled.div`
  height: 25%;
  width: 100%;
  margin: 10px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const PlaceBidButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 280px;
  height: 56px;
  padding: 19px 60px 18px;
  border-radius: 30px;
  background-color: #fb0e56;
  box-sizing: border-box;
`

const TextArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #fff;
`

const BidValuesWrapper = styled.div`
  padding-left: 15px;
  padding-right: 15px;
  display: inline;
  text-align: center;
  display: flex;
  flex-wrap: wrap;
`

const FilterOptionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  color: #212121;
`

const BidSignal = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 70%;
  padding: 10px 0;
`
const Signal = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

const Green = styled.div`
  width: 18px;
  height: 18px;
  background-color: #03c452;
  border-radius: 50%;
`
// const Orange = styled.div`
//   width: 18px;
//   height: 18px;
//   background-color: #f00;
//   border-radius: 50%;
// `
const Red = styled.div`
  width: 18px;
  height: 18px;
  background-color: #f00;
  border-radius: 50%;
`
const Text = styled.span`
  color: #dfe4ff;
  font-family: montserratLight;
  font-size: 14px;
  margin-left: 10px;
`
const NoteBox = styled.div`
  width: 100%;
  margin: 20px 0;
  padding: 20px;
  border-radius: 8px;
  background-color: #ffd089;
  box-sizing: border-box;
  color: #522f00;
  font-family: montserratLight;
  font-size: 16px;
`
const Footer = styled.div`
  position: fixed;
  bottom: 20px;
  max-width: 460px;
  display: block;
  padding: 10px;
  width: 100%;
  box-sizing: border-box;
`

const WinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 10px;
  box-sizing: border-box;
`
const WinningBid = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
`

const AllBidHeading = styled.div`
  color: #fff;
  font-family: "montserratLight";
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 0;
`

const WinnerDeclare = styled.div`
  font-family: "montserratLight";
  color: #fff;
  text-transform: uppercase;
  font-size: 18px;
  margin: 5px;
`

class ExpiredBids extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showAboutBidInfo: true,
      anchorEl: null,
      filterOption: [
        { label: i18n.t("All"), value: true },
        { label: i18n.t("GoodBids"), value: false },
        { label: i18n.t("OkBids"), value: false },
        { label: i18n.t("BadBids"), value: false },
        { label: i18n.t("LatestBids"), value: false },
      ],
      activeFilter: { label: "All", value: true },
      bidsRemaining: 0,
      startBid: 0,
      endBid: 0,
    }
    this.loadData = this.loadData.bind(this)
    this.placeBid = this.placeBid.bind(this)
    this.applyFilters = this.applyFilters.bind(this)
    this.handleCheckBoxClick = this.handleCheckBoxClick.bind(this)
    this.handlePopoverClick = this.handlePopoverClick.bind(this)
    this.getDisplayName = this.getDisplayName.bind(this)
    this.popoverClose = this.popoverClose.bind(this)
    this.hideAboutBidding = this.hideAboutBidding.bind(this)
  }

  openBidPopup(data) {
    this.props.showPopup({
      // renderComponent: () => <BidType  onClick={() => this.placeBid(show)} />,
      renderComponent: () => <BidType data={data} onClick={this.placeBid} />,
      showPopup: true,
      style: {
        background: "transparent",
        boxShadow: "none",
      },
    })
  }

  componentWillMount() {
    this.loadData()
  }

  componentWillUnmount() {
    const { removeData, uniqueId } = this.props
    removeData({
      uniqueId,
    })
  }

  loadData() {
    const { fetchData, uniqueId } = this.props
    console.log("unq", uniqueId)
    fetchData({
      uniqueId,
      method: "GET",
      uri: `/userExpBids/${get(this.props, "match.params.offerId")}`,
      onSuccess: (res) => {
        console.log("expired bids", res)
        // this.setState({ bidsRemaining: res.bidsRemaining || 0 })
      },
    })

    // fetchData({
    //   uniqueId,
    //   method: "GET",
    //   uri: `/zone?offerId=${get(this.props, "match.params.offerId")}`,
    //   onSuccess: (res) => {
    //     this.setState({ startBid: res.safeZoneStart }),
    //       this.setState({ endBid: res.safeZoneEnd })
    //   },
    // })
  }

  placeBid() {
    const { history, showToast, match } = this.props
    if (this.state.bidsRemaining > 0) {
      history.push(
        `/play/place-bids/${replaceWithSymbol(
          get(match, "params.title")
        )}/${get(match, "params.offerId")}`
      )
      this.props.showPopup({})
      event({
        category: "My Bid Page",
        action: "Place Bid",
      })
    } else {
      showToast({
        text: "You don't have sufficient bids.",
        variant: "warning",
      })
      event({
        category: "My Bid Page",
        action: "You don't have sufficient bids.",
      })
    }
  }

  handlePopoverClick(e) {
    this.setState({
      anchorEl: e.currentTarget,
    })
    event({
      category: "My Bid Page",
      action: "Bid Type Popover Open",
    })
  }

  popoverClose() {
    this.setState({ anchorEl: null })
    event({
      category: "My Bid Page",
      action: "Bid Type Popover Close",
    })
  }

  handleCheckBoxClick(e, index, activeFilter) {
    const filterOption = [...this.state.filterOption]
    for (let i = 0; i < filterOption.length; i++) {
      if (i === index && e.target.checked) {
        const { showToast } = this.props
        filterOption[i].value = e.target.checked
        showToast({
          text: `${filterOption[i].label} ` + i18n.t("Selected"),
          variant: "info",
        })
        event({
          category: "My Bid Page",
          action: filterOption[i].label,
        })
      } else {
        filterOption[i].value = false
      }
    }
    this.setState({
      activeFilter,
      filterOption: filterOption,
    })
  }

  applyFilters(data, { label }) {
    if (data) {
      switch (label) {
        case "All": {
          return orderBy(data, ["bidValue"], ["asc"])
        }
        case i18n.t("GoodBids"): {
          console.log(
            "Data filter GOod :",
            orderBy(
              filter(data, { bidHealth: "goodBid" }),
              ["bidValue"],
              ["asc"]
            )
          )
          return orderBy(
            filter(data, { bidHealth: "goodBid" }),
            ["bidValue"],
            ["asc"]
          )
        }
        case i18n.t("BadBids"): {
          return orderBy(
            filter(data, { bidHealth: "badBid" }),
            ["bidValue"],
            ["asc"]
          )
        }
        // case i18n.t("OkBids"): {
        //   return orderBy(
        //     filter(data, { bidHealth: "okBid" }),
        //     ["bidValue"],
        //     ["asc"]
        //   )
        // }
        // case "UniqueBids": {
        //   return orderBy(
        //     filter(data, { isUnique: true }),
        //     ["bidValue"],
        //     ["asc"]
        //   )
        // }
        // case "RepeatedBids": {
        //   return orderBy(
        //     filter(data, { isUnique: false }),
        //     ["bidValue"],
        //     ["asc"]
        //   )
        // }
        case "LatestBids": {
          return orderBy(data, ["date", "time"], ["desc", "desc"])
        }
        default:
          return data
      }
    }
    return data
  }

  getDisplayName() {
    let test = find(this.state.filterOption, { value: true })
    return test.label || i18n.t("All")
  }

  hideAboutBidding() {
    this.setState({ showAboutBidInfo: false })
    event({
      category: "My Bid Page",
      action: "About Bid Close",
    })
  }

  render() {
    let { data } = this.props
    console.log("this.props", this.props)
    const {
      showAboutBidInfo,
      filterOption,
      activeFilter,
      anchorEl,
      startBid,
      endBid,
      bidsRemaining,
    } = this.state
    console.log("DATATA : ", this.props)
    const open = Boolean(anchorEl)
    if (!data) {
      return null
    } else if (data.error) {
      return <span>{data.error}</span>
    }
    let myBidsData = this.applyFilters(
      get(data, "data.bidDetails"),
      activeFilter
    )
    let hasData = isArray(myBidsData) && !isEmpty(data.data.bidDetails)
    console.log("hasDataa", myBidsData)
    // const newBidsData = [
    //   { bidValue: "00.29", date: "28/04/2021", isUnique: false, time: "17:19" },
    //   { bidValue: "00.09", date: "28/04/2021", isUnique: true, time: "18:19" },
    //   { bidValue: "00.29", date: "28/04/2021", isUnique: false, time: "17:19" },
    //   { bidValue: "00.09", date: "28/04/2021", isUnique: true, time: "18:19" },
    //   { bidValue: "00.29", date: "28/04/2021", isUnique: false, time: "17:19" },
    //   { bidValue: "00.09", date: "28/04/2021", isUnique: true, time: "18:19" },
    //   { bidValue: "00.29", date: "28/04/2021", isUnique: false, time: "17:19" },
    //   { bidValue: "00.09", date: "28/04/2021", isUnique: true, time: "18:19" },
    //   { bidValue: "00.29", date: "28/04/2021", isUnique: false, time: "17:19" },
    //   { bidValue: "00.09", date: "28/04/2021", isUnique: true, time: "18:19" },
    //   { bidValue: "00.29", date: "28/04/2021", isUnique: false, time: "17:19" },
    //   { bidValue: "00.09", date: "28/04/2021", isUnique: true, time: "18:19" },
    //   { bidValue: "00.29", date: "28/04/2021", isUnique: false, time: "17:19" },
    //   { bidValue: "00.09", date: "28/04/2021", isUnique: true, time: "18:19" },
    //   { bidValue: "00.29", date: "28/04/2021", isUnique: false, time: "17:19" },
    //   { bidValue: "00.09", date: "28/04/2021", isUnique: true, time: "18:19" },
    //   ...myBidsData,
    // ]
    const title = this.props.match.params.title
    const modifiedTitle = title.replace(/-/g, " ")
    const Data = get(data, "data")
    console.log("Data : ", Data)
    // const bidsRemaining = get(data, "data.auctionDetailsDTO.bidsRemaining", 0)
    return (
      <div className='container'>
        <Header>
          <img
            // onClick={() =>
            //   this.props.history.push(
            //     `/play/product-details/${get(
            //       this.props,
            //       "match.params.title"
            //     )}/${get(this.props, "match.params.offerId")}`
            //   )
            // }
            onClick={() => this.props.history.goBack()}
            className='arrow'
            src={`${config.MRBIDNWIN_S3_IMAGE_URL}/arrow_back.svg`}
            alt='back-arrow'
            style={{ cursor: "pointer" }}
          />
          {/* <Label>{i18n.t("MyBids")}</Label> */}
          <Label>{modifiedTitle}</Label>
          {/* {hasData && (
            <div>
              <img
                src={`${config.MRBIDNWIN_S3_IMAGE_URL}/ic-filter.svg`}
                ref='target'
                onClick={this.handlePopoverClick}
                alt='MyBids-Filters'
              />
              <Popover
                id='simple-popper'
                open={open}
                anchorEl={anchorEl}
                onClose={this.popoverClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "center",
                }}
              >
                <div
                  style={{
                    padding: "10px 15px",
                    background: "#383d5a",
                    border: "1px solid #383d5a",
                  }}
                >
                  {filterOption.map((obj, index) => {
                    return (
                      <FilterOptionContainer
                        className='checkbox_container'
                        key={index}
                      >
                        <b
                          className='montserratLight'
                          style={{
                            marginRight: 20,
                            color: "#fff",
                            fontSize: "14px",
                          }}
                        >
                          {obj.label}
                        </b>
                        <input
                          onClick={(event) =>
                            this.handleCheckBoxClick(event, index, obj)
                          }
                          className='checkbox'
                          checked={obj.value}
                          type='checkbox'
                          disabled={obj.value}
                        />
                      </FilterOptionContainer>
                    )
                  })}
                </div>
              </Popover>
            </div>
          )} */}
        </Header>
        {/* <BidTab liveBids={myBidsData} expiredBids={myBidsData} /> */}

        <div className='container_body'>
          {hasData ? (
            <BidFoundContainer>
              {Data && Data.isWinner ? (
                <WinnerContainer>
                  {/* <p>Congratulation</p> */}
                  <img
                    src={`${
                      config.BIDNWIN_S3_IMAGE_URL_NEW_UI
                    }/congratulation2.png`}
                    style={{ width: "100%", maxWidth: "290px" }}
                  />
                  <WinnerDeclare>{i18n.t("YouWinner")}</WinnerDeclare>
                </WinnerContainer>
              ) : (
                <WinnerContainer>
                  <p
                    style={{
                      color: "#808080",
                      fontFamily: "montserratLight",
                      fontSize: "13px",
                    }}
                  >
                    {i18n.t("WinnerName")}
                  </p>
                  <WinnerDeclare>{Data.winnerName}</WinnerDeclare>
                </WinnerContainer>
              )}
              <WinningBid>
                {/* <h2>Winning Bid</h2>
                <div style={{ padding: "10px 30px" }}>
                  <div
                    style={{
                      width: "100%",
                      border: "solid 1px #434550",
                    }}
                  />
                </div> */}
                <BidValue
                  number={Data.bidAmount}
                  className='goodBid'
                  expired='true'
                />
              </WinningBid>
              {/* <br /> */}

              {/* {showAboutBidInfo && (
                <AboutBidding hideAboutBidding={this.hideAboutBidding} />
              )} */}

              <Footer>
                <AllBidHeading>{i18n.t("AllBidsPlaced")}</AllBidHeading>
                <div style={{ padding: "10px 30px" }}>
                  <div
                    style={{
                      width: "100%",
                      border: "solid 1px #434550",
                    }}
                  />
                </div>
                <BidValuesWrapper
                  style={{
                    justifyContent:
                      myBidsData.length > 5 ? "center" : "flex-start",
                  }}
                >
                  {myBidsData.map((obj, index) => {
                    console.log(" OBJ ", obj)
                    return (
                      <BidValue
                        key={index}
                        number={obj.bidValue}
                        // className={
                        //   obj.isUnique
                        //     ? "preSeletedUniqueFloatBid"
                        //     : "preSeletedRepeatedFloatBid"
                        // }
                        //className={obj.isUnique ? "goodBid" : "badBid"}
                        className={obj.bidHealth}
                      />
                    )
                  })}
                </BidValuesWrapper>
                <div style={{ padding: "10px 30px" }}>
                  <div
                    style={{
                      width: "100%",
                      border: "solid 1px #434550",
                    }}
                  />
                </div>
                <BidSignal>
                  <Signal>
                    <Green />
                    <Text>{i18n.t("Good")}</Text>
                  </Signal>
                  {/* <Signal>
                    <Orange />
                    <Text>{i18n.t("Okay")}</Text>
                  </Signal> */}
                  <Signal>
                    <Red />
                    <Text>{i18n.t("Bad")}</Text>
                  </Signal>
                </BidSignal>
              </Footer>
            </BidFoundContainer>
          ) : (
            <Fragment>
              <NoBidFoundContainer>
                <ImageWrapper>
                  <img
                    style={{ width: "40%" }}
                    src={`${
                      config.MRBIDNWIN_S3_IMAGE_URL
                    }/ic-facebook-login-bidding.svg`}
                    alt='Logo'
                  />
                </ImageWrapper>
                <TextArea>
                  <b className='montserratSemiBold'>{i18n.t("NoBidsPlaced")}</b>
                  <div
                    className='montserratRegular'
                    style={{ margin: "10px 0px" }}
                  >
                    {i18n.t("FirstBidPlaced")}
                  </div>
                </TextArea>
                <PlaceBidButton>
                  <PrimaryButton
                    label='Place Bid'
                    variant='contained'
                    style={{
                      width: "70%",
                      height: 54,
                      backgroundColor: "#fb0e56",
                    }}
                    onClick={this.placeBid}
                  />
                </PlaceBidButton>
              </NoBidFoundContainer>
              {/* {showAboutBidInfo && (
                <AboutBidding hideAboutBidding={this.hideAboutBidding} />
              )} */}
            </Fragment>
          )}
        </div>
      </div>
    )
  }
}

ExpiredBids = connect(
  (state, ownProps) => {
    let mapStateToProps = {}
    if (state.data && state.data[ownProps.uniqueId]) {
      mapStateToProps.data = state.data[ownProps.uniqueId]
    }
    return mapStateToProps
  },
  {
    fetchData,
    removeData,
    showToast,
    showPopup,
  }
)(ExpiredBids)

export default class ExpiredBidsWrapper extends React.Component {
  componentWillMount() {
    this.uuid = uuid.v4()
    const locale = Cookie.get("X-Reycreo-Language-Id")
    i18n.changeLanguage(locale || "en")
    console.log("RENDER ExpiredBidsWrapper :: ", locale)
  }

  render() {
    return <ExpiredBids {...this.props} uniqueId={this.uuid} />
  }
}



// WEBPACK FOOTER //
// ./src/views/MyBids/expired-bids.js